import script from "./KeyNumberEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./KeyNumberEdit.vue?vue&type=script&setup=true&lang=js"

import "./KeyNumberEdit.vue?vue&type=style&index=0&id=fecfc008&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/h-waterwork-storeroom-webui_prev/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fecfc008"]])

export default __exports__